/*
* show Spacing X dropdown based on tab route or v-scored
*/
import React from 'react'
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'immutable-prop-types';
import SelectComponent from 'pu-react/components/SelectComponent';
import {
  arraySpacingX as tooltipVScore,
  arraySpacingXTabRouted as tooltipTabRouted,
} from 'pu-data/Tooltips';
import { spacingTabRouted, spacingVScored } from 'pu-data/SelectOptions'

const SpacingX = (props) => {
  const { parameters } = props
  const selectedName = parameters.tab_rout === '1' ? 'array_spacing_x_tab_rout' : 'array_spacing_x_vscore'
  const onChange = e => props.onChangeParameter(selectedName, e.target.value);

  const spacingXTabRouted = (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={props.name}
      onChange={props.onChange || onChange}
      options={spacingTabRouted}
      tooltip={tooltipTabRouted}
      selected={parameters[selectedName] || ''}
      groupName={props.groupName} />)
  const spacingXVscore = (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={props.name}
      onChange={props.onChange || onChange}
      options={spacingVScored}
      tooltip={tooltipVScore}
      selected={parameters[selectedName] || ''}
      groupName={props.groupName} />)
  const Component = parameters.tab_rout === '1' ? spacingXTabRouted : spacingXVscore
  return (<div>{Component}</div>)
};

SpacingX.defaultProps = {
  label: 'Spacing in X',
  name: 'array_spacing_x',
  required: true,
  onChange: null,
};

// SpacingX.propTypes = {
//   label            : PropTypes.string,
//   name             : PropTypes.string,
//   required         : PropTypes.bool,
//   onChange         : PropTypes.func,
//   parameters       : ImmutablePropTypes.map.isRequired,
//   onChangeParameter: PropTypes.func.isRequired,
// }

export default SpacingX;
